import React from "react";

const Footer = () => {
    const titulo = process.env.REACT_APP_SITE_TITLE || "Cursos";
    return (
        <footer className="footer">
            <p>© {new Date().getFullYear()} {titulo}</p>
        </footer>
    );
};

export default Footer;
